var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKlicklyPixelHandLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#klicklyPixelHandLogo_svg__a)",
  fillRule: "evenodd",
  d: "M15.615 41.531h-2.372v-4.44h-2.208v-4.363h-2.29v-4.365h-2.29v-2.338H4V19.17h7.117v2.338h2.126V2.18h2.536v28.91h-2.617v-7.402H10.79l.082-2.182H6.7v4.363h2.043v2.26h2.291v4.442h2.208v4.44h2.373zh2.29v4.208h18.896v-4.208h2.209v-6.78h2.29v6.78h-2.21V48H15.615zm.246-39.35V0h4.58v2.182zm7.117 19.87H20.44V2.181h2.7v8.65h4.499v2.18h6.79v2.339h4.745v2.103h2.21v2.183h-2.21v-2.104h-2.538v6.31H34.43v-8.413H30.01v6.312h-2.37V13.17h-4.663zm18.407 12.702v-15.04H44v15.04z",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "klicklyPixelHandLogo_svg__a",
  x1: 45.08,
  x2: -2.226,
  y1: -23.059,
  y2: 60.689,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A0A0A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.099,
  stopColor: "#FFF0A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.285,
  stopColor: "gold"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.796,
  stopColor: "#FF41F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DF33FF"
})))));
export default SvgKlicklyPixelHandLogo;